export function OperatorSkullIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Helmet */}
      <path d="M5.5 11V9.5C5.5 6.5 8 4 12 4s6.5 2.5 6.5 5.5V11" />

      {/* NVG rail + mount */}
      <path d="M8.5 7h7" />
      <rect x={10.2} y={5.6} width={3.6} height={1.3} rx={0.2} />

      {/* NVG tubes (3 lenses) */}
      <circle cx={9.4} cy={8.7} r={0.9} />
      <circle cx={12} cy={8.7} r={0.9} />
      <circle cx={14.6} cy={8.7} r={0.9} />

      {/* Skull head */}
      <path d="M8 11.2c0-1.9 1.6-3.2 4-3.2s4 1.3 4 3.2v2.1c0 1-.5 2-1.3 2.6l-.7.6v1.7H10v-1.7l-.7-.6C8.5 15.3 8 14.3 8 13.3v-2.1z" />

      {/* Teeth / jaw */}
      <path d="M10 18.2v1.2l1 1h2l1-1v-1.2" />
      <path d="M11.2 17.6v1.4M12.8 17.6v1.4" />
    </svg>
  );
}



